import { authHeaders, betterFetch, CCS_URL } from './helper';

/**
 * gets archived pages for startDate and endDate filters
 *
 * @function
 * @param {object} params - function params
 * @param {string} params.end - end date for filtering archived content
 * @param {string} params.start - start date for filtering archived content
 * @param {string} params.type - type for filtering archived content
 * @returns {Promise.<object[]>} response data
 */
export const getArchivedContent = function getArchivedContent({ end, start, type }) {
  const headers = authHeaders();
  const params = new URLSearchParams({ end, start, type });
  const url = `${CCS_URL}/archive/getArchivedContent?${params}`;

  return betterFetch(url, { headers });
};

/**
 * unarchive pages for startDate and endDate filters
 *
 * @function
 * @param {object} params - function params
 * @param {object[]} params.content - array of `id` and `type` objects for restoration
 * @returns {Promise.<object[]>} response data
 */
export const restoreContent = function restoreContent({ content }) {
  const headers = authHeaders();
  const options = {
    method: 'POST',
    headers,
    body: JSON.stringify(content)
  };

  return betterFetch(`${CCS_URL}/archive/restoreContent`, options);
};
